// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OrderNote_wrapper__3Dqz3","footer":"OrderNote_footer__1r7ZD"};